var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feature-avatar',{directives:[{name:"shared-element",rawName:"v-shared-element:[heroIdProfileAvatar]",arg:_vm.heroIdProfileAvatar}],attrs:{"size":100,"src":_vm.src,"lazy-src":_vm.srcLazy}})}
var staticRenderFns = []

export { render, staticRenderFns }